// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__11hTy","overflowing":"ReadFullNote_overflowing__2iOKU"};